import { browser } from '$app/environment';

export type StorageType = 'local' | 'session';

function getStorage(storageType: StorageType, window: Window & typeof globalThis): Storage {
	switch (storageType) {
		case 'local':
			return window.localStorage;
		case 'session':
			return window.sessionStorage;
		default:
			throw new Error(`Invalid storage type: ${storageType}, storage type must be 'local' or 'session'`);
	}
}

export function sessionOrLocaleStorage(storageType: StorageType, key: string) {
	if (!browser) return;
	const storage = getStorage(storageType, window);

	return {
		get() {
			if (!browser) return;
			return storage.getItem(key);
		},
		set(value: string) {
			if (!browser) return;
			storage.setItem(key, value);
		},
		remove() {
			if (!browser) return;
			storage.removeItem(key);
		},
		clear() {
			if (!browser) return;
			storage.clear();
		},
	};
};
